
import {useEffect, useState} from "react";

function RouteLogout(props) {


    useEffect(() => {

    }, []);

    return (
        <div className="view logout">

        </div>
    );
}

export default RouteLogout;
